import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Table } from 'antd'

import buildColumns from './TableColumns'
import css from './Dashboard.css'

class PracticeTable extends Component {
  static propTypes = {
    practicesStatsAndProducts: PropTypes.arrayOf(
      PropTypes.shape({
        stats: PropTypes.shape({
          average_messages_per_day: PropTypes.number,
          last_sync: PropTypes.string,
          messages_today: PropTypes.number,
        }),
        practice: PropTypes.shape({
          name: PropTypes.string.isRequired,
          id: PropTypes.number.isRequired,
          onboarding: PropTypes.bool.isRequired,
        }).isRequired,
        phone_numbers: PropTypes.arrayOf(PropTypes.string).isRequired,
        products: PropTypes.arrayOf(PropTypes.string).isRequired,
      }).isRequired,
    ).isRequired,
    editPractice: PropTypes.func.isRequired,
    isTopsAdmin: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    loginToPractice: PropTypes.func.isRequired,
    updateData: PropTypes.func.isRequired,
    recents: PropTypes.bool.isRequired,
  }

  mapDataSource = () =>
    this.props.practicesStatsAndProducts.map(
      ({
        practice,
        practice_stats,
        phone_numbers,
        products,
        active_locations_count,
      }) => ({
        key: practice.id,
        practice,
        stats: practice_stats,
        phoneNumbers: phone_numbers,
        products,
        activeLocationsCount: active_locations_count,
      }),
    )

  // pass props to header row
  onHeaderRow = () => ({
    className: css.headerRow,
  })

  renderColumns = () => {
    const { loginToPractice, editPractice, isTopsAdmin, updateData, recents } =
      this.props
    return buildColumns(
      loginToPractice,
      editPractice,
      isTopsAdmin,
      updateData,
      recents,
    )
  }

  render() {
    return (
      <Table
        columns={this.renderColumns()}
        dataSource={this.mapDataSource()}
        loading={this.props.loading}
        onHeaderRow={this.onHeaderRow}
        pagination={false}
      />
    )
  }
}

export default PracticeTable



// WEBPACK FOOTER //
// ./src/Dashboard/PracticeTable.js